/**
 * @this component needs to refactoring
 */

import { connect } from 'react-redux';
import React, { Component, Fragment } from 'react';
import BlurWrap from './blurWrap/BlurWrap';
import { FacebookShareButton } from 'react-share';
import styles from './hatchPopup.css';
import Close from 'assets/svg/close.svg';
import BackArrow from 'assets/svg/arrow_back-white-18dp.svg';
import { bindActionCreators } from 'redux';
import {
    startHatchGame,
    answerHatchQuestion,
    shareChallengeCalendar,
    setEventSound,
    claerHatchData,
    setTimerValue
} from 'data/player/calendar/action';

import { playerAdvertisingClick } from 'data/calendar/players/actions';
import { collectionStatisticsShare } from 'data/sharing/actions';
import Question from 'components/calendar/components/question/Question';
import Registration from './components/Registration';
import CutText from 'components/cutText/CutText.jsx';
import ChallengeWindow from 'components/challengeWindow/ChallengeWindow.jsx';
import FeedbackWindow from './components/feedbackWindow/FeedbackWindow';
import get from 'lodash.get';
import { getSwitchClassNameOrColourWithBackground, wrapUrlByTag, sendUserDetails, getShareURL } from '../../../../../../utils/func';
import { setCookie } from 'utils/cookieService';
import uuid from 'uuid/v1';
import Diagram from './components/diagram/Diagram';
import moment from 'moment';
import Counter from '../../../../../../components/counter/Counter.jsx';
import { Progress } from 'semantic-ui-react';
import RegistrationButtonCalendar from './RegistrationButtonCalendar/RegistrationButtonCalendar.jsx';
import TopListWindow from '../../../../../../components/calendar/components/question/questionTypes/shared/topListWindow/TopListWindow.jsx';
import Replay from '../../../../../../assets/svg/replay.svg';
import { requestPlayerCalendarCover } from '../../../../../../data/player/calendar/api';
import { deleteCookie, getCookie } from '../../../../../../utils/cookieService';
import { saveViewHatch } from 'data/calendar/hatch/actions';
import Crown from '../../../../../../assets/svg/crown2.svg';
import ShareListNotPopUp from '../../../../../../components/common/shareList/ShareListNotPopUp';

const mapStateToProps = ( { hatchGameData, hatchGameProgress: { timeOut }, localization: { content }, shareChallenge } ) => ( {
    hatchGameData,
    timeOut,
    content,
    shareChallenge
} );


const mapDispatchToProps = dispatch => ( {
    calendarPlayerActions: bindActionCreators( {
        startHatchGame,
        answerHatchQuestion,
        collectionStatisticsShare,
        shareChallengeCalendar,
        playerAdvertisingClick,
        setEventSound,
        claerHatchData,
        setTimerValue,
        saveViewHatch
    }, dispatch )
} );

const printDate = ( date ) => {
    const currentDate = date !== null ? date : new Date();
    const now = moment( currentDate );
    const month = now.format( 'MMMM' ).slice( 0, 3 ) + '. ';
    const day = now.format( 'DD' );
    return `${ month } ${ day }`;
};
const urlShare = getShareURL(getCookie( 'uuid' ), 'none', null);

@connect( mapStateToProps, mapDispatchToProps )
class HatchPopup extends Component {
    constructor() {
        super();
        this.state = {
            startGame: true,
            startGameDidUpdateDom: true,
            currentQuestion: null,
            statistics: null,
            game: null,
            currentView: null,
            statisticsPopup: false,
            registrationPopup: false,
            challengePopup: false,
            timeOut: null,
            uuid: '',
            imageHeight: null,
            registrationHeight: null,
            imgUrl: '',
            statusAppend: true,
            stylePopRef: {},
            hatchWrapperOpacity: { opacity: '1' },
            openClose: false,
            showTextPollQuestionResult: false,
            questionStatistics: undefined,
            showExternalBtnInfo: false,
            showInterbalPage: false,
            isThereBonusDoorInTheCalendar: false,
            isRegistrationSkipped:false,
            isHideReplayButton:false,
            topListData: null,
        };
        this.backgroundRef = null;
        this.backgroundVideoRef = null;
        this.statPopuRef = null;
        this.questionBodySecond = null;
        this.timerValueStart = null;
        this.timerValueEnd = null;
        this.hatchHeaderRef = React.createRef();

    };

    componentDidMount() {
        const { calendarPlayerActions: { claerHatchData } } = this.props;
        claerHatchData();
        this.updateDimensions();
        window.addEventListener( 'resize', () => this.updateDimensions() );
        this.insertEmbedHtml();
        this.soundFreeze();
        const isThereBonusDoorInTheCalendar = this.isThereBonusDoorInTheCalendar();
        this.setState( { isThereBonusDoorInTheCalendar: isThereBonusDoorInTheCalendar } );
    };

    /*******************************************************************************************************************
     *
     *******************************************************************************************************************/
    insertEmbedHtml = () => {
        const { hatch } = this.props;

        if ( hatch.embedded_html && this.backgroundVideoRef ) {
            this.backgroundVideoRef.insertAdjacentHTML( 'afterBegin', hatch.embedded_html );
        }
    };

    updateDimensions() {
        const { hatch, calendarPlayerActions: { playerAdvertisingClick } } = this.props;

        if ( this.backgroundRef ) {
            this.setState( { imageHeight: this.backgroundRef.offsetWidth * 0.75 }, () => {
                if ( this.backgroundRef.hasChildNodes() ) {
                    let iframe = document.getElementsByTagName( 'iframe' )[ 0 ];

                    if ( iframe ) {
                        iframe.onload = () => {
                            this.backgroundVideoRef.onKeyPress = () => {
                                playerAdvertisingClick( 'adv_vid', hatch.id, 'iframe.onload event' );
                            };
                        };
                    }
                }
            } );
        }
    }

    /*******************************************************************************************************************
     *
     ******************************************************************************************************************/
    handleStartClick = () => {
        const { calendar, calendar: { registration_settings }, registered } = this.props;
        if ( !registered && registration_settings && registration_settings.enabled && registration_settings.appearance === 'before' ) {
            this.setState( { registrationPopup: true } );
        } else if ( calendar ) {
            this.startPlay();
        }
    };

    /*******************************************************************************************************************
     *
     ******************************************************************************************************************/
    startPlay = () => {
        const { calendarPlayerActions: { startHatchGame }, hatch, hatch: { id }, disablePlayedHatch, setComponentVisible, setAnimationProcess } = this.props;

        if ( this.state.startGame ) {

            this.setState( {
                startGame: false,
                currentView: 'question',
                registrationPopup: false,
                timeOut: null
            }, () => {
                setAnimationProcess( false );
                setComponentVisible( 'question' );
                this.soundNextSound();

                new Promise( ( resolve ) => {
                    const { country } = this.props.userIdentifier;
                    startHatchGame( id, country, resolve );
                } ).then( () => {
                    disablePlayedHatch( hatch );
                } );
            } );

        }
    };

    /*******************************************************************************************************************
     *
     * @param e
     ******************************************************************************************************************/
    handleClick = e => {
        e.stopPropagation();
        e.preventDefault();
    };

    /*******************************************************************************************************************
     *
     * @param e
     ******************************************************************************************************************/

    heightRegistration = e => {
        this.setState( { registrationHeight: e } );
    };

    /******************************************************************************************************************
     *
     * @param answerObject
     *****************************************************************************************************************/
    answerQuestion = ( answerObject ) => {
        const { calendarPlayerActions: { answerHatchQuestion }, hatch: { id }, setAnimationProcess } = this.props;
        this.timerValueEnd = new Date().getTime();
        const answerTime = this.timerValueEnd - this.timerValueStart;
        answerHatchQuestion( id, this.state.game.id, { ...answerObject, answer_time: answerTime } );
        this.setState( { statisticsPopup: true } );
        this.soundFreeze();
        setAnimationProcess( true );

    };


    /*******************************************************************************************************************
     *
     ******************************************************************************************************************/
    soundFreeze = () => {
        if ( typeof this.props.soundFreezetMethod !== 'undefined' ) {
            this.props.soundFreezetMethod();
        }
    };


    /*******************************************************************************************************************
     *
     ******************************************************************************************************************/
    soundNextSound = () => {
        if ( typeof this.props.soundNextPlayMethod !== 'undefined' ) {
            this.props.soundNextPlayMethod();
        }
    };


    componentDidUpdate( prewProps, prewState ) {
        const { handleHatchOpen } = this.props;
        const { openClose } = this.state;

        if ( openClose ) {
            setTimeout( () => handleHatchOpen( null ), 100 );
            this.setState( { openClose: false } );
        }


        if ( (JSON.stringify(this.props.hatchGameData)!==JSON.stringify(prewProps.hatchGameData) )
            && ( this.state.timeOut === null || typeof this.state.timeOut === 'undefined' || this.state.statisticsPopup || this.state.showTextPollQuestionResult ) ) {
            this.setState( { timeOut: this.props.timeOut } );
            const { hatchGameData } = this.props;

            if ( !hatchGameData.statistics ) {

                this.setState( {
                    currentQuestion: hatchGameData.question,
                    game: this.state.game && this.state.game.id === hatchGameData.game.id ? this.state.game : hatchGameData.game
                });

            } else {

                this.setState( {
                    statistics: {
                        ...this.state.statistics,
                        ...hatchGameData.statistics,
                        gameStatistics: { ...hatchGameData.statistics.gameStatistics },
                        questionStatistics: { ...hatchGameData.statistics.question_statistics },
                        usersStatistics: hatchGameData.statistics.questionsStatistics
                    }
                }, () => {
                    if ( this.props.hatchGameData.question.type === 'text_poll' &&
                        this.props.hatchGameData.statistics &&
                        this.props.hatchGameData.statistics.question_statistics.questionSkipped ) {
                        this.statisticsPopupClick();
                    }
                } );
            }

        } else if ( this.props.timeOut && !this.state.statisticsPopup && !this.state.registrationPopup ) {
            this.setState( { timeOut: this.props.timeOut } );
            this.answerQuestion( {
                timeOut: true,
                type: this.state.currentQuestion.localization.answer_model,
                question_localization_id: this.state.currentQuestion.localization.id
            } );
        }

        if ( JSON.stringify( this.props.shareChallenge ) !== JSON.stringify( prewProps.shareChallenge ) ) {
            this.setState( {
                uuid: this.props.shareChallenge.key
            } );
        }

    };

    /******************************************************************************************************************
     *
     ******************************************************************************************************************/
    timerDidUprate = () => {
        this.timerValueStart = new Date().getTime();
    };

    /**
     * *****************************************************************************************************************
     *
     ******************************************************************************************************************/
    setCanvas = () => {
        if ( ( this.state.startGame === false ) && this.state.startGameDidUpdateDom ) {
            this.setState( { startGameDidUpdateDom: false }, () => {
                this.timerValueStart = new Date().getTime();
            } );
        }
    };

    /******************************************************************************************************************
     *
     *****************************************************************************************************************/
    statisticsPopupClick = () => {
        const { hatchGameData: { statistics }, calendar: { registration_settings }, registered, setComponentVisible, setAnimationProcess, calendarPlayerActions:{ setTimerValue } } = this.props;
        setTimerValue( {
            timeOut: false
        } );

        this.setState( { statisticsPopup: false, timeOut: undefined });

        if ( statistics.is_last ) {

            if ( !registered && registration_settings && registration_settings.enabled && registration_settings.appearance === 'after' && !this.props.calendar?.playerRegistred ) {
                this.setState( { registrationPopup: true } );
            } else {
                this.setState( { currentView: 'result' } );
                setComponentVisible( 'result' );
            }

        } else {
            this.setState( {
                currentView: 'question',
                currentQuestion: statistics.nextQuestion,
                statistics: null
            }, () => {
                setComponentVisible( 'question' );
                this.soundNextSound();
                setAnimationProcess( false );

                this.timerValueStart = new Date().getTime();
            } );
        }
    };

    /*******************************************************************************************************************
     *
     * @param resultObj
     ******************************************************************************************************************/

    showResultView = resultObj => {

        this.setState( {
                currentView: 'result',
                registrationPopup: false,
                imageHeight: null,
            },
            () => {
                this.props.setComponentVisible( 'result' );
                this.setState( {
                    statistics: {
                        ...this.state.statistics,
                        gameStatistics: {
                            ...this.state.statistics.gameStatistics,
                            bonus_points: resultObj.bonus_points,
                            ranking: resultObj.ranking,
                            points: resultObj.points ? resultObj.points : this.state.statistics.gameStatistics.points,
                            pointsAlreadyReceived: resultObj.pointsAlreadyReceived
                        }
                    }
                });
            } );
    };

    /******************************************************************************************************************
     *
     *
     *****************************************************************************************************************/
    handleFacebookBtnClick = () => {
        const { calendarPlayerActions: { shareChallengeCalendar }, hatch: { id } } = this.props;
        shareChallengeCalendar( this.props.calendar.id, id, 'calendar' );
        this.setState( { challengePopup: true } );
    };

    /*******************************************************************************************************************
     *
     * @param str
     *******************************************************************************************************************/
    copyToClipboard = str => {
        const tmpArea = document.createElement( 'textarea' );
        tmpArea.value = str;
        tmpArea.setAttribute( 'readonly', '' );
        tmpArea.style.position = 'absolute';
        tmpArea.style.left = '-9999px';
        document.body.appendChild( tmpArea );
        tmpArea.select();
        document.execCommand( 'copy' );
        document.body.removeChild( tmpArea );
        alert( 'Link coppied to clipboard' );
    };

    /******************************************************************************************************************
     *
     ******************************************************************************************************************/
    collectionStatistics = () => {
        const {
            calendarPlayerActions: { collectionStatisticsShare },
            hatch: { id }
        } = this.props;
        collectionStatisticsShare( id, 'hatch' );
    };

    /*******************************************************************************************************************
     *
     * @returns {string}
     ******************************************************************************************************************/
    readAdvUrl = () => {
        const { hatch: { adv_url } } = this.props;

        if ( adv_url.indexOf( 'http' ) === 0 ) {
            return adv_url;
        } else {
            return `//${ adv_url }`;
        }
    };

    /******************************************************************************************************************
     *
     * @returns {string|*}
     *********************************************************************************************************************/
    readButtonObj = () => {
        const buttonObj = JSON.parse( this.props.hatch.button );
        if ( buttonObj.url.indexOf( 'http' ) === 0 ) {
            return buttonObj.url;
        } else {
            return `//${ buttonObj.url }`;
        }
    };

    /*******************************************************************************************************************
     *
     ******************************************************************************************************************/
    setSound = () => {
        const { calendarPlayerActions: { setEventSound } } = this.props;
        setEventSound( { events: 'hover' } );

    };

    /*******************************************************************************************************************
     *
     */

    showDataTextPollQuestion = () => {
        this.setState( { showTextPollQuestionResult: true } );
    };


    newCookie = ( props, call ) => {
        if ( !getCookie('uuid') ) {
            let genUUID = uuid();
            setCookie( 'uuid', genUUID, 1800 );
            setCookie( 'isCookiesAccepted', true, 365 * 5 );
            if ( typeof call === 'function' ) {
                call();
            }
        }
    }


    isThereBonusDoorInTheCalendar = () => {
        try {
            const { calendar: { hatches } } = this.props;
            const types = hatches?.map( ( elm ) => {
                return elm.type;
            } );
            return types.includes( 'bonus' );
        } catch ( e ) {
            console.error( e );
            return false;
        }
    }

    getCalendarCover = () => {
        const { hatch: { id } } = this.props;
        let isPreviewMode = false;
        const params = new URLSearchParams( this.props.location.search );
        if(params) {
            const previewParams = params.get( 'preview' );
            isPreviewMode = Boolean( previewParams );
        }
        const sendFields = sendUserDetails();
        return requestPlayerCalendarCover( id, { ...sendFields, isPreviewMode } );
    }

    getReplayFunction = () => {
        const { calendar, setComponentVisible, setAnimationProcess } = this.props;
        let newRegistrationEachGameEnabled = [];
        if ( calendar?.registration_form ) {
            const regFormObj = JSON.parse( calendar?.registration_form );
            const fieltData = regFormObj?.defaultFields;
            newRegistrationEachGameEnabled = fieltData.filter(setting => {
                return setting.alias === 'newRegistrationEachGame';
            });
            this.setState( {
                currentView: 'question',
                // isRegistrationSkipped: false,
                // isHideReplayButton: true,
                statistics: null
            }, () => {
                setComponentVisible( 'question' );
                this.soundNextSound();
                setAnimationProcess( false );
                if(newRegistrationEachGameEnabled.length){
                    deleteCookie( 'uuid' );
                    deleteCookie( 'isCookiesAccepted' );
                    this.setState({ startGame: true, isRegistrationSkipped: true }, () => {
                        this.newCookie( this.props );
                        if ( this.props.hatch ) {
                            saveViewHatch( this.props.hatch.id );
                        }
                        this.startPlay();
                    });
                } else {
                    this.getCalendarCover();
                    this.setState({ startGame: true, isRegistrationSkipped: false }, () => {
                        if ( this.props.hatch ) {
                            saveViewHatch( this.props.hatch.id );
                        }
                        this.startPlay();
                    });
                }
            });
        }
        
        this.timerDidUprate();
        this.setState( {
            currentView: 'question',
            statistics: null
        }, () => {
            setComponentVisible( 'question' );
            this.soundNextSound();
            setAnimationProcess( false );
            if(newRegistrationEachGameEnabled.length){
                deleteCookie( 'uuid' );
                deleteCookie( 'isCookiesAccepted' );
                this.setState({ startGame: true }, () => {
                    this.newCookie( this.props );
                    if ( this.props.hatch ) {
                        saveViewHatch( this.props.hatch.id );
                    }
                    this.startPlay();
                });
            } else {
                this.getCalendarCover();
                this.setState({ startGame: true }, () => {
                    if ( this.props.hatch ) {
                        saveViewHatch( this.props.hatch.id );
                    }
                    this.startPlay();
                });
            }
        });
    };


    handleCallback = (childData) => {
        this.setState({ topListData: childData });
    };
    
    clickChallenge = () => {
        this.setState( { challengePopup: true } )
    }

    render() {
        const buttonObj = JSON.parse( this.props.hatch.button );

        const {
            currentView,
            currentQuestion,
            statistics,
            statisticsPopup,
            registrationPopup,
            challengePopup,
            imageHeight,
            registrationHeight,
            hatchWrapperOpacity,
            showTextPollQuestionResult,
            showExternalBtnInfo,
            showInterbalPage,
            isThereBonusDoorInTheCalendar,
            isRegistrationSkipped,
            isHideReplayButton
        } = this.state;

        const {
            hatch,
            handleCloseHatchPopup,
            calendar,
            content,
            contentColor,
            location,
            registered,
            calendar: { settings },
            calendarPlayerActions: { playerAdvertisingClick, setEventSound }, fontFamilyH2, fontFamily
        } = this.props;
        const LinkButtonObj = JSON.parse( hatch.external_url_button );
        const titleStyle = hatch?.title_style ? JSON.parse( hatch.title_style ) : {};
        const descriptionStyle = hatch?.description_style ? JSON.parse( hatch.description_style ) : {};
        const legalStyle = hatch?.legal_style ? JSON.parse( hatch.legal_style ) : {};
        
        
        let LinkButtonObjText = '';

        if ( Boolean( hatch.external_url ) && LinkButtonObj !== null && typeof LinkButtonObj !== 'undefined' ) {
            LinkButtonObjText = ( LinkButtonObj.button_text && LinkButtonObj.button_text.length > 25 ) ? LinkButtonObj.button_text && LinkButtonObj.button_text.slice( 0, 25 ) + '...' : LinkButtonObj.button_text && LinkButtonObj.button_text;
        }

        const fontStyle = calendar && calendar.settings.appearance.font_style ? calendar.settings.appearance.font_style : { color: contentColor.dark };
        let styleCanvas = contentColor.type === 'light' ? 'rgba(0,0,0,0.8)' : contentColor.type === 'dark' ? 'rgba(255,255,255,0.8)' : 'inherit';

        const blurStyle = { backgroundColor: hatch.background };
        const titleColour = getSwitchClassNameOrColourWithBackground( hatch.background, '#030303', '#fff' );
        const textColour = getSwitchClassNameOrColourWithBackground( calendar.settings.appearance.inner_background, '#030303', '#fff' );
        const innerHeight = registrationPopup ? { height: `calc(${ registrationHeight }px + 15rem)` } : {};
        const { start_date } = hatch;
        const printDateText = printDate( start_date );


        return (
            <div className={ styles.hatchWrapper }
                 style={ calendar && {
                     ...fontStyle, ...innerHeight, ...hatchWrapperOpacity,
                     backgroundColor: calendar.settings.appearance.inner_background ?
                         calendar.settings.appearance.inner_background : 'rgba(0, 0, 0, .5)'
                 } }>
                <div className={ styles.hatchHeader } style={ blurStyle } ref={ this.hatchHeaderRef }>
                    <div className={ styles.headerTitle } style={ { color: titleColour } }>

                        { !calendar.settings.set_specific_dates &&
                        <span className={ styles.headerDay }>{ content.calendar.day }&nbsp;</span> }

                        <span className={ styles.hatchId }>
                            { calendar.settings.set_specific_dates ? printDateText :
                                hatch.order }
                        </span>
                    </div>

                    { showExternalBtnInfo || showInterbalPage ?
                        <div className={ styles.headerBack }
                             onClick={ () => {
                                 if ( showInterbalPage ) this.setState( { showInterbalPage: false } );
                                 if ( showExternalBtnInfo ) this.setState( { showExternalBtnInfo: false }, () => {
                                     this.insertEmbedHtml();
                                 } );
                             } }>
                            <span style={ { color: `${ styleCanvas }` } }>{ content.calendar.back }</span>
                            <BackArrow style={ { fill: `${ styleCanvas }` } }/>
                        </div> :

                        <div className={ styles.headerClose }
                             onClick={ () => {
                                 this.soundFreeze();

                                 this.setState( { hatchWrapperOpacity: { opacity: '0' }, openClose: true }, () => {
                                     handleCloseHatchPopup();
                                 } );
                             } }>
                            <Close/>
                        </div>
                    }
                </div>
                
                { registrationPopup &&
                <Registration
                    contentColor={ contentColor }
                    location={ location }
                    regHeight={ this.heightRegistration }
                    startPlay={ this.startPlay }
                    showResultView={ this.showResultView }
                    resetTimeout={ this.resetTimeout }
                    fontFamilyH2={ fontFamilyH2 }
                    calendar={ calendar }
                    hatchId={ hatch.id }
                    beforeSkipClicked={ (registerProps) => {
                        if(currentView == 'result'){
                            this.showResultView(registerProps)
                        } else { this.startPlay(); }
                        
                        this.state.isRegistrationSkipped = true; 
                        this.state.isHideReplayButton = false; } }
                    afterSkipClicked={ () => {
                        this.setState( { registrationPopup: false } );
                        this.setState( { currentView: 'result' } );
                        this.state.isRegistrationSkipped = true;
                        this.state.isHideReplayButton = false;
                    } }
                    parentCallback={this.handleCallback}
                    currentView = {this.state.currentView}
                /> }

                { currentView === 'question' && currentQuestion && !registrationPopup
                    ?
                    <div className={ styles.questionBody }
                         style={ registrationPopup ? {
                             filter: 'blur(10px)',
                             background: 'inherit',
                             pointerEvents: 'none'
                         } : null }>
                        <BlurWrap

                            props={ this.props }
                            setCanvas={ this.setCanvas }
                            timerDidUprate={ this.timerDidUprate }>
                            <Question
                                contentColor={ contentColor }
                                content={ content }
                                question={ currentQuestion }
                                statistics={ statistics }
                                handleAnswerSelection={ this.answerQuestion }
                                statisticsPopup={ statisticsPopup }
                                setEventSound={ setEventSound }
                                calendar={ calendar }
                                showTextPollQuestionResult={ showTextPollQuestionResult }
                                clickAfterTextPollQuestion={ this.statisticsPopupClick }
                            />

                        </BlurWrap>

                        { statisticsPopup && statistics &&
                        <FeedbackWindow
                            setSound={ this.setSound }
                            question={ currentQuestion }
                            statistics={ statistics }
                            statisticsPopupClick={ this.statisticsPopupClick }
                            styleCanvas={ styleCanvas }
                            button_style={ get( calendar, 'settings.appearance.button_style' ) }
                            fontFamilyH2={ fontFamilyH2 }
                            contentColor={ contentColor }
                            content={ content }
                            settings={ settings }
                        />
                        }
                    </div>
                    : ( currentView === 'result' && !registrationPopup ) ? 
                    <>
                        <div className={ styles.mainHatchContainer}>
                            <div className={ styles.container}>
                                <div style={{ width:'50%' }}>
                                    <div className={ styles.hatchLeftBox}>
                                        { settings.show_points && 
                                        <div className={ styles.progressHeadText}>
                                            {statistics.gameStatistics.points} {content.popup.points}
                                        </div>
                                        
                                        }
                                        {statistics.gameStatistics.max_points > 0 && 
                                            <div className={ styles.progressText} id="progressText">
                                                {typeof statistics.gameStatistics.points === 'number' ? <Counter to = { Math.round((statistics.gameStatistics.points / statistics.gameStatistics.max_points) * 100)} duration={30} /> : 0} %
                                            </div>
                                        }
                                        
                                        <div className={ styles.progressContainer}>
                                            <div className={ styles.progressBar} id="myProgressBar">
                                            <Progress color='grey'
                                                style={{ 'backgroundColor': 'black' }}
                                                className={ styles.resultProgress}
                                                percent={Math.round((statistics.gameStatistics.points / statistics.gameStatistics.max_points) * 100)} size='small' inverted />
                                            </div>
                                        </div>

                                        {!isRegistrationSkipped ?
                                            <div className={ styles.hatchBtn2} style={{ textAlign: 'center'}}>
                                                {<p className={styles.getBonusPoints}
                                                    style={{ fontFamily: fontFamily }}
                                                > {content.calendar.get_bonus_points}</p>
                                                }
                                                <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                                                    <a  onClick={this.clickChallenge}
                                                        className={styles.registerBtn}>
                                                        <Crown
                                                            style={{ fill: '#fff', width: '2.6rem', height: '3.1rem' }} />
                                                        <span
                                                            className={styles.btnShareText}
                                                            aria-label={ content.calendar.share_with_your_friends_aria_label }
                                                        >
                                                            {content.calendar.share_with_your_friends || 'Share with your friends'}
                                                        </span>
                                                    </a>
                                                </div>
                                            </div>
                                            : null
                                        }

                                        {isRegistrationSkipped ?
                                            <div style={{ textAlign: 'center'}}>
                                                <RegistrationButtonCalendar text={content.Register_to_get_bonus_points}
                                                    registerAgain={() => {
                                                        this.setState({ registrationPopup: true });
                                                        this.setState({ currentView: 'result' });
                                                        this.setState({ isRegistrationSkipped: false });
                                                    }}
                                                    customStyle={{
                                                        ...settings.appearance.button_secondary_style,
                                                        fontFamily: fontFamily
                                                    }}
                                                />
                                            </div>
                                            : null
                                        }

                                        {isHideReplayButton ?
                                            null :
                                            <div style={{ textAlign: 'center', marginTop:'10px'}}>
                                                <a 
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        fontFamily: fontFamily
                                                    }}
                                                    onClick={ this.getReplayFunction }
                                                    aria-label={ content.calendar.replay_aria_label }
                                                    className={styles.replayBtn}>
                                                    <Replay style={{
                                                        fill: '#fff',
                                                        width: '2rem',
                                                        height: '2rem'
                                                    }}
                                                    />
                                                    <span
                                                        className={styles.replayBtnText}> {content.calendar.replay}</span>
                                                </a>
                                            </div>
                                        }
                                                        
                                    </div>
                                    <div className={ styles.hatchLeftBox}>
                                        {currentView === 'result' && !registrationPopup ?
                                            <div className={styles.makeOwn} style={{ textAlign: 'center'}}>
                                                <span
                                                    className={styles.replayBtnText}> {content.calendar.make_own_quiz}
                                                </span> <br/>
                                                <button 
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        fontFamily: fontFamily
                                                    }}
                                                    aria-label={ content.calendar.make_own_quiz_button_aria_label }
                                                    className={styles.calendarBtn}>
                                                    {content.calendar.make_own_quiz_button}
                                                </button>
                                            </div>
                                            : null 
                                        }
                                    </div>

                                </div>
                                <div style={{ width:'50%' }}>
                                    { ( !isRegistrationSkipped && calendar.settings.leaderboard && this.state.topListData ) ?
                                        <TopListWindow 
                                                    // replayGame={ getReplayFunction() }
                                                    isHideReplayButton={ isHideReplayButton }
                                                    font_family={ fontFamily }
                                                    topList={Object.values(this.state.topListData) }
                                                    placeColor={ calendar.settings.appearance.button_style.background }
                                                    calendar={ calendar}/>
                                        :
                                        null
                                    }

                                    { isRegistrationSkipped && calendar.settings.leaderboard ?
                                        <div className={ styles.hatchRightBox }>
                                            <div className={ styles.hatchBtn1 }>
                                                <RegistrationButtonCalendar text={content.Register_to_see_toplist}
                                                    registerAgain={() => {
                                                        this.setState({ registrationPopup: true });
                                                        this.setState({ currentView: 'result' });
                                                        this.setState({ isRegistrationSkipped: false });
                                                    }}
                                                    customStyle={{
                                                        ...settings.appearance.button_secondary_style,
                                                        fontFamily: fontFamily
                                                    }}
                                                />
                                            </div>
                                            { calendar.settings.share_btn ? 
                                                <ShareListNotPopUp
                                                    urlShare={ urlShare }
                                                    uuid={ getCookie( 'uuid' ) }
                                                    gameID={ hatch.calendar_id }
                                                    titleQuiz={ '' }
                                                    imgBg={ null }
                                                    descriptionQuiz={ '' }
                                                    content={ content }
                                                    quizType={ '' }
                                                    backgroundColor={ settings.appearance.background_color }
                                                />
                                                : null
                                            }
                                            
                                        </div>
                                        : null
                                    }
                                </div>
                            </div>             
                        </div>
                    </>
                        :
                        registrationPopup ?
                            null
                            : 
                            ( <Fragment>
                                    { showExternalBtnInfo || showInterbalPage ?
                                        <div className={ styles.textWrapper }>
                                            <h3 style={ Object.assign( {}, { borderColor: contentColor.dark }, fontFamilyH2 ) }>
                                                { showExternalBtnInfo && LinkButtonObj.title }
                                                { showInterbalPage && buttonObj.internalTextTitle }
                                            </h3>
                                            <p style={ { fontFamily: fontFamily } }>
                                                { showExternalBtnInfo && LinkButtonObj.text }
                                                { showInterbalPage && buttonObj.internalText }
                                            </p>
                                        </div>
                                        :
                                        <div className={ styles.hatchBody }>
                                            <div className={ styles.hatchImage } ref={ node => this.backgroundRef = node }

                                                 style={ imageHeight ?
                                                     { height: `${ imageHeight }px` }
                                                     : this.backgroundRef && { height: `${ this.backgroundRef.offsetWidth * 0.75 }px` } }
                                            >
                                                <a target={ '_blank' }
                                                   ref={ node => this.backgroundVideoRef = node }
                                                   href={ hatch && hatch.adv_url && !hatch.embedded_html ? `${ this.readAdvUrl() }` : hatch && hatch.embedded_html ? '#' : null }>
                                                    { hatch.image &&
                                                    <img onClick={ () => {
                                                        playerAdvertisingClick( 'adv_img', hatch.id, hatch && hatch.adv_url && !hatch.embedded_html ? `${ this.readAdvUrl() }` : hatch && hatch.embedded_html ? '#' : null );
                                                    } } src={ hatch.image.url } alt='img'/> }

                                                </a>
                                                { hatch.inactiveContent &&
                                                <div className={ styles.hatchInactiveContent }>{ calendar.settings.hatch_display_message ? calendar.settings.hatch_display_message : 'Unfortunately, time for playing has passed' }</div> }
                                                <div className={ styles.linkButtonWrap }>
                                                    { Boolean( calendar.settings.share_btn ) &&
                                                    <FacebookShareButton
                                                        quote={ hatch.title }
                                                        url={
                                                            `${ window.location.href }?img=${ hatch.image ? hatch.image.image : '' }&title=${ hatch.title }&desc=${ hatch.description }&hatch=${ hatch.id }&sharing`
                                                        }
                                                        onShareWindowClose={ this.collectionStatistics }
                                                        className={ styles.fbShare }>{ content.popup.facebook }
                                                    </FacebookShareButton> }
                                                </div>

                                            </div>
                                            <div className={ styles.hatchInfo }

                                                 style={ calendar && {
                                                     ...calendar.settings.appearance.font_style,
                                                     height: `${ this.backgroundRef?.offsetWidth * 0.75 }px`
                                                 } }>
                                                <div className={ styles.wrapperContentText }>
                                                    <h2 className={ styles.hatchTitle }
                                                        style={ { color: textColour, fontFamilyH2, ...titleStyle } }
                                                    >{ hatch.title }</h2>
                                                    { hatch.description &&
                                                    <p style={ { color: textColour, ...descriptionStyle } }
                                                       className={ styles.hatchDesc }
                                                       dangerouslySetInnerHTML={ { __html: wrapUrlByTag( hatch.description ) } }/> }
                                                </div>
                                                <div className={ styles.bottomInfo }>
                                                    <div className={ styles.bottomSubWrapp }>
                                                        { hatch.legal ?
                                                            <div className={ styles.aElm1 }>
                                                                <CutText
                                                                    textStyle={ legalStyle }
                                                                    textClass={ styles.hatchLegal }
                                                                    popupTextClass={ styles.textPopup }
                                                                    popupClass={ styles.popupWindow }
                                                                    text={ hatch.legal }
                                                                    fontFam={ 'Overpass, sans-serif' }
                                                                    format={ 0 }
                                                                    fColor={ contentColor.dark }
                                                                    contentColor={ contentColor }
                                                                    lineCount={ 3 }
                                                                    content={ content }
                                                                    visibleIcon
                                                                />
                                                            </div> : null
                                                        }

                                                        {/* @Need to refactoring  */ }
                                                        { hatch && Boolean( hatch.external_url ) ?

                                                            <div
                                                                className={ `${ styles.btnLinkWrap } ${ styles.aElm2 }` }>
                                                                <h5 className={ styles.hatchLegal }
                                                                    onClick={ () => this.setState( { showExternalBtnInfo: true } ) }>
                                                                    { LinkButtonObjText }
                                                                </h5>
                                                            </div> : null }
                                                    </div>
                                                    { buttonObj && buttonObj.isInternalPage ?
                                                        <a onClick={ () => this.setState( { showInterbalPage: true } ) }
                                                           className={ styles.startButton }
                                                           aria-label={ content.calendar.start_aria_label }
                                                           style={ calendar && { ...calendar.settings.appearance.button_style } }
                                                        >
                                                            { buttonObj.text ? buttonObj.text : content.calendar.start }
                                                        </a> : null
                                                    }


                                                    {/*@Need to refactoring  */ }
                                                    { buttonObj && Boolean( buttonObj.isExternal ) &&

                                                    <a onClick={ () => {
                                                        playerAdvertisingClick( 'adv_btn', hatch.id, buttonObj.url ? `${ this.readButtonObj() }` : '#' );
                                                    } }
                                                       target={ '_blank' }
                                                       href={ buttonObj.url ? `${ this.readButtonObj() }` : '#' }
                                                       className={ styles.startButton }
                                                       aria-label={ content.calendar.start_aria_label }
                                                       style={ calendar && { ...calendar.settings.appearance.button_style } }
                                                    >
                                                        { buttonObj.text ? buttonObj.text : content.calendar.start }
                                                    </a>
                                                    }

                                                    {/*@Need to refactoring  */ }
                                                    { buttonObj &&
                                                    buttonObj.isQuiz &&
                                                    hatch.questionsCount &&
                                                    ( !hatch.alreadyPlayed && hatch.active && !hatch.inactive_day_after ) &&

                                                    <button
                                                        onMouseEnter={ this.setSound }
                                                        onClick={ this.handleStartClick }
                                                        className={ styles.startButton }
                                                        aria-label={ content.calendar.start_aria_label }
                                                        style={ calendar && { ...calendar.settings.appearance.button_style } }
                                                    >
                                                        { buttonObj && buttonObj.text ? buttonObj.text : content.calendar.start }
                                                    </button>
                                                    }
                                                    { buttonObj &&
                                                    buttonObj.isQuiz &&
                                                    hatch.questionsCount &&
                                                    ( !hatch.alreadyPlayed && hatch.active && hatch.inactive_day_after && !calendar.settings.hatch_seeable_not_playable ) &&

                                                    <button
                                                        onMouseEnter={ this.setSound }
                                                        onClick={ this.handleStartClick }
                                                        className={ styles.startButton }
                                                        aria-label={ content.calendar.start_aria_label }
                                                        style={ calendar && { ...calendar.settings.appearance.button_style } }
                                                    >
                                                        { buttonObj && buttonObj.text ? buttonObj.text : content.calendar.start }
                                                    </button>
                                                    }
                                                    {/*@Need to refactoring  */ }
                                                    { buttonObj && buttonObj.isQuiz &&
                                                    hatch.questionsCount && ( hatch.alreadyPlayed && hatch.active ) &&
                                                    <Fragment>
                                                        <button

                                                            onClick={ () => {
                                                                playerAdvertisingClick(
                                                                    'adv_btn',
                                                                    hatch.id,
                                                                    buttonObj && buttonObj.text ? buttonObj.text : content.calendar.start );
                                                            }
                                                            }
                                                            onMouseEnter={ this.setSound }
                                                            disabled={ true }
                                                            className={ styles.startButton }
                                                            aria-label={ content.calendar.start_aria_label }
                                                            style={ calendar && { ...calendar.settings.appearance.button_style } }
                                                        >
                                                            { buttonObj && buttonObj.text ? buttonObj.text : content.calendar.start }

                                                        </button>

                                                        { !( !hatch.alreadyPlayed && hatch.active ) &&
                                                        <i

                                                            className={ styles.infoButtonDisable }
                                                            style={ { color: contentColor.dark } }>
                                                            { content.calendar.question_already_answered }
                                                        </i>
                                                        }
                                                    </Fragment>
                                                    }

                                                </div>
                                            </div>
                                        </div> }
                                </Fragment>
                            )
                }

                { challengePopup && (
                    <ChallengeWindow
                        closeChallengePopup={ () => this.setState( { challengePopup: false } ) }
                        titleQuiz={ '' }
                        type={ 'calendar' }
                        id={ hatch.calendar_id }
                        content={ content }
                        allowChallenges={ true }
                        settings={ {
                            show_points: settings.show_points,
                            reward_amount: calendar.settings.reward_amount,
                            challenge_enable: ( calendar.settings.challenge_enable !== 0 ) && ( calendar.settings.reward_amount > 0 ),
                            appearance: { ...calendar.settings.appearance }
                        }
                        }
                    />
                ) }

            </div>
        );
    };
}

export default HatchPopup;
